import { LoaderCircle } from 'lucide-react'

export function FeatureLoader() {
  return <div className="feature-loader" role="status" aria-live="polite">
    <LoaderCircle size={28} strokeWidth={2.25} aria-hidden="true" />
    <span className="sr-only">Đang tải</span>
  </div>
}
